import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import AnimatedArcs from '../AnimatedArcs';
import FormLightboxButton, {
	IFormLightboxButtonProps,
} from '../FormLightboxButton';

export interface IMainHeroSoftwareProps extends IBaseElementProps {
	logo?: IImage;
	heading?: string;
	/**
	 * @control textarea
	 */
	description?: string;
	ctaButtonOne?: ILink;
	ctaButtonTwo?: ILink;
	formLightboxButton?: IFormLightboxButtonProps;
	featuredImage?: IImage;
	arcsPosition: 'Left' | 'Right';
}

/**
 * Calian Main Hero - Software
 * @icon cover-image
 * @block
 */
const MainHeroSoftware: React.FC<IMainHeroSoftwareProps> = ({
	className,
	classNames = [],
	logo,
	heading,
	description,
	ctaButtonOne,
	ctaButtonTwo,
	formLightboxButton,
	featuredImage,
	arcsPosition = 'Right',
}) => (
	<div className="calian-main-hero">
		<div className={className || cn('main-hero-software', ...classNames)}>
			<div className="main-hero-software__background">
				<AnimatedArcs
					arcsStyle={'Component - Two Lines'}
					arcsPosition={arcsPosition}
					arcOneColor={'var(--bs-secondary)'}
					arcOneStrokeWidth={4}
					arcTwoColor={'var(--bs-white)'}
					arcTwoStrokeWidth={3}
					animationDelay={250}
					animationOffset={150}
				/>
			</div>
			<div className="main-hero-software__container container-fluid py-6 pt-xl-12">
				<div className="row">
					<div className="main-hero-software__content col-12 mw-641px mx-auto">
						{logo && (
							<div className="main-hero-software__logo d-flex align-items-center justify-content-center mw-240px mx-auto pt-2 pb-4">
								<Image className="img-fluid" {...logo} />
							</div>
						)}
						{heading && (
							<h1 className="main-hero-software__heading text-center text-white mb-4">
								{heading}
							</h1>
						)}
						{description && (
							<p className="main-hero-software__description text-center text-white subheading">
								{description}
							</p>
						)}
						<div className="main-hero-software__cta-buttons d-flex flex-column flex-sm-row justify-content-center pt-2">
							{ctaButtonOne && ctaButtonOne.label && (
								<Button
									className="btn btn-light"
									{...ctaButtonOne}
								/>
							)}
							{ctaButtonTwo && ctaButtonTwo.label && (
								<Button
									className="btn btn-secondary mt-3 mt-sm-0 ms-sm-3"
									{...ctaButtonTwo}
								/>
							)}
							{formLightboxButton?.formLightboxButton?.label
								?.length > 0 && (
								<FormLightboxButton {...formLightboxButton} />
							)}
						</div>
					</div>
				</div>
				{featuredImage && (
					<div className="row pt-6">
						<div className="main-hero-software__featured-image col-12 mw-850px mx-auto text-center">
							<Image className="img-fluid" {...featuredImage} />
						</div>
					</div>
				)}
			</div>
		</div>
	</div>
);

export default MainHeroSoftware;
